module.exports = __webpack_public_path__ + "static/media/the-etho-homepage-curated-2.56040172.jpeg";